import { render } from "./FriendChat.vue?vue&type=template&id=97bb7eaa&scoped=true"
import script from "./FriendChat.vue?vue&type=script&lang=js"
export * from "./FriendChat.vue?vue&type=script&lang=js"

import "./FriendChat.vue?vue&type=style&index=0&id=97bb7eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97bb7eaa"]])

export default __exports__